<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="cssLayoutRowStartCenter">
  <div class="sp-icon">
    <mat-icon class="mdi-24px" fontIcon="mdi-bank" [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
  </div>
  <mat-form-field style="width: 300px; margin-left: 10px;">
    <input matInput [formControl]="filterControl" placeholder="Search" />
    @if (filterControl.value) {
    <button mat-icon-button matSuffix (click)="filterControl.setValue(''); $event.stopPropagation()" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
  <div class="button-end">
    <mat-paginator #paginator [pageIndex]="0" [pageSize]="20"
      [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]"></mat-paginator>
  </div>
</div>

<div class="frame">
  <section class="scrolling-region">
    <span>
      <div class="table">
        <mat-table #table [dataSource]="showTemplates ? templateDataSource : organizationDataSource" matSort
          (matSortChange)="sortChanged($event)">
          <!-- action column -->
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef class="column-action">
              @if (showTemplates && canEdit) {
              <span>
                <button mat-icon-button (click)="addOrEditOrganization(null, true)" title="Add a template organization"
                  style="outline: none;">
                  <mat-icon class="mdi-24px center-self" fontIcon="mdi-plus-circle"></mat-icon>
                </button>
              </span>
              } &nbsp;
              @if (!showTemplates && (canEdit || msel.hasRole(loggedInUserId, null).owner)) {
              <span>
                <button mat-icon-button [matMenuTriggerFor]="addMenu" style="outline: none;"
                  title="Add organization">
                  <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
                </button>
              </span>
              } &nbsp;
              <mat-menu #addMenu="matMenu" [overlapTrigger]="false">
                <button mat-menu-item (click)="addOrEditOrganization(null, false)" title="Add a new organization">New
                  Organization</button>
                @for (template of templateDataSource.data; track template.id) {
                <button mat-menu-item (click)="addOrEditOrganization(template, false)"
                  title="{{ template.name }} - {{ template.summary }}">{{ template.shortName }}</button>
                }
              </mat-menu>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="column-action">
              <div class="action-div">
                @if (canEdit || (!showTemplates && msel.hasRole(loggedInUserId, null).owner)) {
                <button mat-icon-button class="msel-action"
                  (click)="addOrEditOrganization(element, showTemplates); $event.stopPropagation();"
                  title="Edit {{ element.name }}">
                  <mat-icon class="mdi-18px" fontIcon="mdi-square-edit-outline"
                    title="Edit {{ element.name }}"></mat-icon>
                </button>
                }
                @if (canEdit || (!showTemplates && msel.hasRole(loggedInUserId, null).owner)) {
                <button mat-icon-button class="msel-action"
                  (click)="deleteOrganization(element); $event.stopPropagation();" title="Delete {{ element.name }}">
                  <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"
                    title="Delete {{ element.name }}"></mat-icon>
                </button>
                }
                @if (!showTemplates && canEdit) {
                <button mat-icon-button class="msel-action"
                  (click)="addOrEditOrganization(element, true); $event.stopPropagation();"
                  title="Make {{ element.name }} a template">
                  <mat-icon class="mdi-18px" fontIcon="mdi-bank" title="Make {{ element.name }} a template"></mat-icon>
                </button>
                }
              </div>
            </mat-cell>
          </ng-container>
          <!-- short name Column -->
          <ng-container matColumnDef="shortname">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="column-shortname">
              Short Name
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="column-shortname">
              {{ element.shortName }}
            </mat-cell>
          </ng-container>
          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="column-name">
              Name
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="column-name">
              {{ element.name }}
            </mat-cell>
          </ng-container>
          <!-- summary Column -->
          <ng-container matColumnDef="summary">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="six-cell">
              Summary
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="six-cell">
              <div class="summary-text">{{ element.summary }}</div>
            </mat-cell>
          </ng-container>
          <!-- row definitions -->
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <!-- No Results Message -->
        @if ((showTemplates && templateDataSource?.filteredData?.length === 0) ||
        (!showTemplates && organizationDataSource?.filteredData?.length === 0)) {
        <div class="text no-results">No results found</div>
        }
      </div>
    </span>
  </section>
</div>
